<template>
    <div class="md:white-box">
        <transition
            name="opacity"
            mode="out-in"
        >
            <Skeletons v-if="isGettingData" />
            <div v-else>
                <p class="text-error h4 mb-2.5">
                    {{ flag==='Y'?'您已申請指定扣取每月費用之順序':'您尚未申請指定扣取每月費用之順序' }}
                </p>
                <div class="border-t border-gray-200 pb-20 md:pb-6">
                    <h4 class="my-2.5 md:my-5">
                        {{ flag==='Y'?'請選擇欲變更之內容':'請輸入欲變更之內容' }}
                    </h4>
                    <div v-if="flag==='Y'">
                        <Radio
                            v-model:checkedValue="applyOption"
                            name="apply"
                            value="N"
                            text="取消指定扣取每月費用之順序"
                            class="pb-2.5"
                        />
                        <Radio
                            v-model:checkedValue="applyOption"
                            name="apply"
                            value="Y"
                            text="變更指定扣取每月費用之順序"
                            class="pb-2.5"
                        />
                    </div>
                    <Radio
                        v-else
                        v-model:checkedValue="applyOption"
                        name="apply"
                        value="Y"
                        text="申請指定扣取每月費用之順序"
                        class="pb-2.5"
                    />
                    <!-- v-if="applyOption!==''" -->
                    <div
                        v-if="applyOption!=='N' && applyOption!==''"
                        class=" overflow-visible p-2.5 md:p-4"
                        :class="applyOption === 'N'?'border-disabled grayscale text-gray-200':'bg-green-100 border-green-gray'"
                    >
                        <div
                            v-for="(item, index) in userData"
                            :key="index"
                            class="py-2.5 first:pt-0 last:pb-0 border-b border-dashed"
                        >
                            <div class="flex justify-between items-center mb-2">
                                <p class="text-base font-bold md:text-[0.9375rem] text-black">
                                    收取順序{{ index+1 }}
                                </p>
                                <div class="px-1 leading-none">
                                    <button
                                        :disabled="disabled || index === 0"
                                        class="disabled:opacity-30"
                                        @click="moveUp(index)"
                                    >
                                        <SvgIcon
                                            icon-name="arrow-down-thin"
                                            class="text-green-600 w-5 h-5 rotate-180 mr-1"
                                        />
                                    </button>
                                    <button
                                        :disabled="disabled || index === userData.length-1"
                                        class="disabled:opacity-30"
                                        @click="moveDown(index)"
                                    >
                                        <SvgIcon
                                            icon-name="arrow-down-thin"
                                            class="text-green-600 w-5 h-5"
                                        />
                                    </button>
                                </div>
                            </div>
                            <div class="md:flex">
                                <div class="mb-2.5 md:w-1/2 md:mr-4 md:mb-0">
                                    <Multiselect
                                        v-model="item.bankNo"
                                        class="select-base can-close"
                                        :options="bankList"
                                        placeholder="投資標的公司/名稱"
                                        label="bankName"
                                        :can-deselect="false"
                                        :disabled="disabled"
                                        no-options-text="無投資標的選項"
                                        no-results-text="查無此標的公司"
                                        @change="setFundCodeAndOptions(item)"
                                    />
                                    <div class="error-msg text-right">
                                        {{ item.errorMessageBankNo }}
                                    </div>
                                </div>
                                <div class="flex md:w-1/2">
                                    <div class="flex-grow mr-2.5 md:mr-4">
                                        <Multiselect
                                            v-model="item.fundCode"
                                            class="select-base can-close"
                                            placeholder="投資標的代號/名稱"
                                            :options="item.bankNo===''||!item.bankNo?fundBankList:groupFundBankList[item.bankNo]"
                                            label="label"
                                            :can-deselect="false"
                                            :disabled="disabled"
                                            searchable
                                            no-options-text="無投資標的選項"
                                            no-results-text="查無此標的代號"
                                            @select="setBankValue(item)"
                                        />
                                        <div class="error-msg text-right">
                                            {{ item.errorMessageFundCode }}
                                        </div>
                                    </div>
                                    <button
                                        class="w-10 h-10 xs:w-12 xs:h-12 flex justify-center items-center rounded ring-1 ring-gray-100"
                                        :class="disabled?'bg-gray-75':'bg-white'"
                                        :disabled="disabled||userData.length === 1"
                                        @click="disabled||userData.length === 1?'':openPopup(index)"
                                    >
                                        <SvgIcon
                                            icon-name="delete_forever"
                                            class=" w-6 h-6 xs:w-8 xs:h-8"
                                            :class="disabled || userData.length === 1?'text-gray-200':'text-gray-700'"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="text-right">
                            <button
                                class="btn text-white btn-sm rounded-full mt-2.5 px-5"
                                type="button"
                                :disabled="userData.length >= 20 || disabled"
                                @click="addItem();"
                            >
                                新增一筆
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
    <PopupBase
        v-model:visiblePopup="visiblePopup"
        closeicon
        :params="dialogContnet.remove"
        @confirm="deleteItem"
        @cancel="visiblePopup = false"
        @handleClose="visiblePopup = false"
    />
    <Bottombar>
        <template #right>
            <ButtonNextService
                v-model:isSubmitOk="isSubmitOk"
                :disabled="isButtonDisabled"
                @click="goNext"
            />
        </template>
    </Bottombar>
    <Loading :is-loading="isLoading" />
</template>

<script>

import { ref, computed, inject, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Multiselect from '@vueform/multiselect';
import PopupBase from '@/components/dialogs/Popup.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Radio from '@/components/radios/Radio.vue';
import { getInfoAF, getfundBankInfoAF, submitAF } from '@/apis/AF';
import Loading from '@/components/Loading.vue';
import dialogContnet from '@/json/dialogContent.js';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import { makeSort } from '@/utils/array/makeSort';
import Skeletons from './Skeletons.vue';

export default {
    components: {
        Bottombar,
        Radio,
        Loading,
        Multiselect,
        PopupBase,
        ButtonNextService,
        Skeletons
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const isSubmitOk = ref(false);
        const visiblePopup = ref(false);
        const loadingCount = ref(0);
        const gettingDataCount = ref(0);
        const applyOption = ref('');
        const isLoading = computed(() => loadingCount.value !== 0);
        const isGettingData = computed(() => gettingDataCount.value !== 0);
        const disabled = computed(() => applyOption.value === 'N');
        const deleteIndex = ref(null);
        const userData = ref([]);
        const bankList = ref([]);
        const fundBankList = ref([]);
        const flag = ref('');
        const initialData = ref([]);
        const result = computed(() => store.state.services.changeItemsResult[code]);

        watch(() => userData.value, () => {
            fundBankList.value.forEach(i => {
                const index = userData.value.findIndex(k => k.fundCode === i.fundCode);
                i.disabled = index > -1;
            });
        }, { immediate: true, deep: true });

        /** 基金分類 */
        const groupFundBankList = computed(() => {
            const list = fundBankList.value.reduce((group, item) => {
                const { bankNo } = item;
                group[bankNo] = group[bankNo] || [];
                group[bankNo].push(item);
                return group;
            }, {});
            return list;
        });
        const isDataChange = computed(() => {
            const dbDate = JSON.stringify(initialData.value);
            const changeDate = JSON.stringify(userData.value);
            return changeDate !== dbDate;
        });
        /** 下一步按鈕是否disabled */
        const isButtonDisabled = computed(() => {
            // 申請或是變更順序
            if (applyOption.value === '') {
                return true;
            } else if (applyOption.value !== 'N') {
                return !isDataChange.value;
            } else {
                // 取消
                if (flag.value === 'Y') {
                    return false;
                } else {
                    return !isDataChange.value;
                }
            }
        });

        /** 取得頁面資料 */
        const getData = () => {
            gettingDataCount.value = 2;
            /** 選單資料 */
            getfundBankInfoAF().then(res => {
                bankList.value = res.data.bankList.map(i => {
                    i.value = i.bankNo;
                    return i;
                });
                fundBankList.value = res.data.fundBankList.map(i => {
                    i.value = i.fundCode;
                    i.label = `${i.fundCode} ${i.fundName} (${i.fundTypeCH})`;
                    return i;
                });
            }).finally(() => {
                gettingDataCount.value -= 1;
            });

            /** 指定扣款順序
            * Y：有申請VU07(已申請)；
            * N：申請VU07後又取消(未申請)；
            * 空白：沒有申請VU07(未申請)(保單無VU07條款,保單有VU07條款但沒有申請)
           */
            getInfoAF().then(res => {
                flag.value = res.data.flag;
                initialData.value = makeSort(res.data.vu07List, 'order');
                userData.value = JSON.parse(JSON.stringify(initialData.value));
                // user不要顯示已申請項目
                // if (userData.value.length === 0 && flag.value !== 'Y') {
                //     applyOption.value = 'Y';
                //     addItem();
                // }
                if (flag.value !== 'Y') {
                    applyOption.value = 'Y';
                }
                addItem();
            }).finally(() => {
                gettingDataCount.value -= 1;
            });
        };
        /** 新增一筆 */
        const addItem = () => {
            const obj = {
                bankNo: null,
                fundCode: null,
            };
            userData.value.push(Object.assign({}, obj));
        };

        if (!result.value) {
            getData();
        } else {
            const { storeInitialData, storeUserData, storeBank, storeFundBank, storeApplyOption, storeFlag } = result.value;
            userData.value = storeUserData;
            initialData.value = storeInitialData;
            bankList.value = storeBank;
            fundBankList.value = storeFundBank;
            applyOption.value = storeApplyOption;
            flag.value = storeFlag;
            if (userData.value.length === 0) {
                addItem();
            }
        }

        const goNext = () => {
            // let errorCount = 0;
            if (applyOption.value === 'N' && flag.value === 'Y') {
                submitData();
            } else {
                loadingCount.value += 1;

                let params = {};
                userData.value.forEach(i => {
                    if (!i.bankNo || i.bankNo === '') i.errorMessageBankNo = '請選擇投資標的公司/名稱';
                    if (!i.fundCode || i.fundCode === '') i.errorMessageFundCode = '請選擇投資標的代號/名稱';
                });

                const hasError = userData.value.some(i => !!i.errorMessageBankNo || !!i.errorMessageFundCode);
                if (hasError) params = dialogContnet.validateMsg;

                if (Object.keys(params).length === 0) {
                    submitData();
                } else {
                    modalShow(params);
                    loadingCount.value -= 1;
                }
            }
        };
        /** 送出資料 */
        const submitData = () => {
            userData.value = applyOption.value === 'N' && flag.value === 'Y' ? [] : userData.value;
            const storeData = {
                storeFlag: flag.value,
                storeInitialData: initialData.value,
                storeUserData: userData.value,
                storeBank: bankList.value,
                storeFundBank: fundBankList.value,
                storeApplyOption: applyOption.value,
            };
            store.dispatch('services/setChangeItemsResult', { code, value: storeData });
            const requestBody = userData.value.map((i, index) => {
                const obj = {
                    uallPert: index + 1,
                    bankNo: i.bankNo,
                    fundCode: i.fundCode,
                };
                return obj;
            });
            submitAF({ funddeFlg: applyOption.value, fundBankList: requestBody }).then(() => {
                isSubmitOk.value = true;
            }).finally(() => {
                loadingCount.value -= 1;
            });
        };

        /** 設定基金欄位與其option */
        const setFundCodeAndOptions = (item) => {
            item.fundCode = '';
            item.errorMessageBankNo = '';
        };

        /** 選擇基金欄位 並設定對應的銀行欄位 */
        const setBankValue = (item) => {
            const obj = fundBankList.value.find(k => {
                return k.fundCode === item.fundCode;
            });
            item.errorMessageFundCode = '';
            item.errorMessageBankNo = '';
            item.bankNo = obj.bankNo;
        };

        /** 刪除燈箱：打開 */
        const openPopup = (i) => {
            if (userData.value.length === 1) return;
            visiblePopup.value = true;
            deleteIndex.value = i;
        };

        /** 刪除項目 */
        const deleteItem = () => {
            userData.value.splice(deleteIndex.value, 1);
            visiblePopup.value = false;
        };

        /** 順序往下 */
        const moveDown = (i) => {
            const obj = userData.value[i];
            userData.value.splice(i, 1);
            userData.value.splice(i + 1, 0, obj);
        };

        /** 順序往上 */
        const moveUp = (i) => {
            const obj = userData.value[i];
            userData.value.splice(i, 1);
            userData.value.splice(i - 1, 0, obj);
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        return {
            isLoading,
            isGettingData,
            applyOption,
            disabled,
            goNext,
            isSubmitOk,
            bankList,
            fundBankList,
            visiblePopup,
            userData,
            moveUp,
            moveDown,
            addItem,
            deleteItem,
            setBankValue,
            setFundCodeAndOptions,
            openPopup,
            flag,
            dialogContnet,
            isButtonDisabled,
            groupFundBankList,
        };
    },
};
</script>
<style scoped lang="scss">
:deep(.multiselect-dropdown) {
    max-height: 13rem;
}
</style>
